export const educationData = [
    {
        id: 1,
        institution: 'University of Cape Town',
        course: 'MSc Electrical Engineering',
        startYear: '2022',
        endYear: 'present'
    },
    {
        id: 2,
        institution: 'BSc (Eng) Electrical & Computer Engineering',
        course: 'University of Cape Town',
        startYear: '2018',
        endYear: '2021'
    },
    {
        id: 3,
        institution: 'Busana High School',
        course: 'Matric',
        startYear: '2015',
        endYear: '2017'
    },
]